module.exports = __webpack_public_path__ + "img/t4-ic2.d64029b2.svg";